export default __webpack_public_path__ + "static/video-2-7c297caa19d937a5dea9d93e70e9a3fb.png";